import { render, staticRenderFns } from "./PageSecurity.vue?vue&type=template&id=8bc1b824&scoped=true&"
import script from "./PageSecurity.vue?vue&type=script&lang=js&"
export * from "./PageSecurity.vue?vue&type=script&lang=js&"
import style0 from "./PageSecurity.vue?vue&type=style&index=0&id=8bc1b824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc1b824",
  null
  
)

export default component.exports